const BARS = [0, 120, 240, 360, 480, 360, 240, 120, 0]

export default function ConsolidationAnimation() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-12">
      <div className="relative flex h-44 w-44 items-center justify-center">
        <span className="absolute inset-0 rounded-full border border-terra-500/50 animate-ripple" />
        <span className="absolute inset-0 rounded-full border border-terra-500/40 animate-ripple" style={{ animationDelay: '0.6s' }} />
        <span className="absolute inset-0 rounded-full border border-terra-500/30 animate-ripple" style={{ animationDelay: '1.2s' }} />
        <span className="h-16 w-16 rounded-full bg-terra-500/90 shadow-[0_0_30px_rgba(181,73,31,.45)] animate-breathe" />
      </div>

      <div className="mt-10 flex h-7 items-end gap-[3px]" aria-hidden="true">
        {BARS.map((delay, i) => (
          <span
            key={i}
            className="w-[3px] origin-bottom rounded-[1.5px] bg-terra-500 animate-wave-bar"
            style={{ height: '100%', animationDelay: `${delay}ms` }}
          />
        ))}
      </div>

      <h2 className="mt-8 text-[15px] font-semibold tracking-[-0.01em] text-ink">
        Consolidation en cours
        <span className="ml-1 inline-block animate-pulse-soft">…</span>
      </h2>
      <p className="mt-1.5 max-w-[320px] text-center text-[12.5px] text-muted">
        Extraction des faits — quelques secondes.
      </p>
    </div>
  )
}
